export const POPUP_CHANGE_ATTRIBUTE = 'POPUP_CHANGE_ATTRIBUTE';
export const SHOW_POPUP = 'SHOW_POPUP';
